import { privateApi } from 'services';
import { BusinessAccountMembership, AddEmployeeAsMembershipData } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchBusinessAccountMemberships = (businessAccountId: string): Promise<BusinessAccountMembership[]> =>
    privateApi.get<BusinessAccountMembership[]>(`business-accounts/${businessAccountId}/memberships`);

const create = async (businessAccountMembership: any): Promise<BusinessAccountMembership> =>
    privateApi.post<BusinessAccountMembership>('business-account-memberships', businessAccountMembership);

const addEmployee = async (addEmployeeAsMembershipData: AddEmployeeAsMembershipData): Promise<void> =>
    privateApi.post<void>('business-account-memberships/add-employee', addEmployeeAsMembershipData);

const updateRole = async (businessAccountMembershipId: string, roleId: string): Promise<BusinessAccountMembership> =>
    privateApi.put<BusinessAccountMembership>(`business-account-memberships/${businessAccountMembershipId}`, {
        role: roleId,
    });

const remove = async (
    businessAccountMembershipId: string,
    businessAccountMembership: BusinessAccountMembership,
): Promise<BusinessAccountMembership> =>
    privateApi.delete<BusinessAccountMembership>(
        `business-account-memberships/${businessAccountMembershipId}`,
        businessAccountMembership,
    );

const resendActivationEmail = async (businessAccountMembershipId: string): Promise<void> =>
    privateApi.post(`business-account-memberships/${businessAccountMembershipId}/resend-activation-email`, null);

export const BusinessAccountMembershipGateway = {
    fetchBusinessAccountMemberships,
    create,
    addEmployee,
    updateRole,
    remove,
    resendActivationEmail,
};

const cancelableFetchBusinessAccountMemberships = (businessAccountId: string): Promise<BusinessAccountMembership[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<BusinessAccountMembership[]>(
        `business-accounts/${businessAccountId}/memberships`,
    );

export const CancelableBusinessAccountMembershipGateway = {
    cancelableFetchBusinessAccountMemberships,
};
